import { DEFAULT_VALUES } from '../FiltersForm.config';

const initialState = {
  ...DEFAULT_VALUES,
};

export default initialState;
